import React from "react"
import { Link } from "react-router-dom"

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

//header page for the game detail page
class Header extends React.Component{
    render(){
        return(
            <div id="detailHeader" role="navigation" style={{width: "100%"}}>
                <Link to="/">
                    <FontAwesomeIcon icon={faChevronLeft} />&nbsp; Back to all games
                </Link>
                {this.props.data !== undefined &&
                <a href="/#">
                    <span style={{fontWeight: 700}}>&nbsp;&nbsp;|&nbsp;&nbsp;{this.props.data.name}</span>
                </a>
                }
            </div>
        )
    }
}

export default Header